module.exports = __webpack_public_path__ + "img/trinidad-and-tobago.e3e1929d.svg";